import { createAsyncThunk } from '@reduxjs/toolkit';
import { _discountUrls } from '@custom/Utils/constants/apiUrls';

const requestDiscount = createAsyncThunk('requestDiscount', async (body:any, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      let url = _discountUrls.request;
      let response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body:JSON.stringify(body)
      });

      if (!response.ok) {
        return rejectWithValue(await response.json());
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  });



export default requestDiscount;
